import { getConfig } from '@superbet-group/web.lib.config';
import { BetSlipPurchaseType } from '@superbet-group/web.types';

export function getAvailableBetslipPurchaseTypes(): BetSlipPurchaseType[] {
    return getConfig().sportsOffer?.isRetailFrontendEnabled
        ? [BetSlipPurchaseType.online, BetSlipPurchaseType.offline]
        : [BetSlipPurchaseType.online];
}

export function getDefaultBetslipPurchaseType(): BetSlipPurchaseType {
    return BetSlipPurchaseType.online;
}

export function getAreTaxDetailsVisible(): boolean {
    return getConfig().countrySpecific.sport.areTaxDetailsVisible ?? false;
}

export function getIsTicketCheckVisible(): boolean {
    return getConfig().sportsOffer?.isRetailFrontendEnabled ?? true;
}

export function getAreRetailCodesVisible(): boolean {
    return getConfig().sportsOffer?.isRetailFrontendEnabled ?? true;
}
